import(/* webpackMode: "eager" */ "/home/ubuntu/download/695d570b7683ed0014bb82c7/code_spring_financials/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/695d570b7683ed0014bb82c7/code_spring_financials/src/app/homepage/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/695d570b7683ed0014bb82c7/code_spring_financials/src/app/homepage/components/InteractiveCalculators.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/695d570b7683ed0014bb82c7/code_spring_financials/src/app/homepage/components/TestimonialsCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/695d570b7683ed0014bb82c7/code_spring_financials/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/695d570b7683ed0014bb82c7/code_spring_financials/src/components/ui/AppIcon.tsx");
